<template>
  <div class="container-fluid bg-light">
    <div class="row vh-100">
      <div class="col-12 col-sm-10 col-md-7 col-lg-6 col-xl-6 col-xxl-4 p-5">
        <router-view/>
      </div>
      <div class="d-none d-lg-block col-lg-6 col-xl-6 col-xxl-8 bg-primary" id="image"/>
    </div>
  </div>
</template>

<style>
#image {
  background-image: url('https://res.cloudinary.com/rubik/image/upload/v1663664936/images/backgrounds/strongman_khl7nw.png');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: top;
}

a {
  text-decoration: none;
}
</style>